import { Component, OnInit, ViewChild } from '@angular/core';
import { Location, PopStateEvent } from '@angular/common';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NavbarComponent, RouteInfo } from '@ov-suite/ui';
import swal from 'sweetalert2';
import { CognitoUser } from '../../models/cognito-user.model';
import { AmplifyService } from 'aws-amplify-angular';
import { hasFeaturePermission, PermissionAction } from '@ov-suite/authguard-angular';
import { FeaturesConfig } from '../../features.config';

@Component({
  selector: 'ov-suite-app-layout',
  templateUrl: './admin-layout.component.html'
})
export class AdminLayoutComponent implements OnInit {
  public routes: Promise<RouteInfo[]>;

  url: string;
  location: Location;
  currentUser: CognitoUser;

  private lastPoppedUrl: string;
  private yScrollStack: number[] = [];
  @ViewChild('sidebar', { static: false }) sidebar;
  @ViewChild(NavbarComponent, { static: false }) navbar: NavbarComponent;

  constructor(
    private router: Router,
    location: Location,
    private amplifyService: AmplifyService
  ) {
    this.location = location;
  }

  ngOnInit() {
    this.amplifyService
      .auth()
      .currentUserInfo()
      .then(user => {
        const attributes = user.attributes;
        this.currentUser = new CognitoUser().fromAWS(attributes);
      });

    const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
    const elemSidebar = <HTMLElement>(
      document.querySelector('.sidebar .sidebar-wrapper')
    );

    this.location.subscribe((ev: PopStateEvent) => {
      this.lastPoppedUrl = ev.url;
    });

    this.router.events.subscribe((event: unknown) => {
      if (event instanceof NavigationStart) {
        if (event.url !== this.lastPoppedUrl) {
          this.yScrollStack.push(window.scrollY);
        }
      } else if (event instanceof NavigationEnd) {
        if (event.url === this.lastPoppedUrl) {
          this.lastPoppedUrl = undefined;
          window.scrollTo(0, this.yScrollStack.pop());
        } else {
          window.scrollTo(0, 0);
        }
      }
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        elemMainPanel.scrollTop = 0;
        elemSidebar.scrollTop = 0;
      });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.navbar.sidebarClose();
      });
    this.routes = this.getRoutes();
  }

  signOut() {
    swal
      .fire({
        title: 'Are you sure you want to sign out?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No, take me back'
      })
      .then(reason => {
        if (reason.value) {
          this.amplifyService
            .auth()
            .signOut()
            .then(() => {
              this.router.navigate(['auth/login']).then();
            })
            .catch(() =>
              alert('There was an issue signing out of your account')
            );
        }
      })
      .catch();
  }

  getRoutes = async (): Promise<RouteInfo[]> => {
    return Promise.resolve(  [
      {
        path: '/dashboard',
        title: 'dashboard',
        icontype: 'fa fa-tachometer',
        type: 'link'
      },
      {
        path: '/management',
        title: 'User Management',
        type: 'sub',
        hidden: await hasFeaturePermission(FeaturesConfig.ManageUsers, PermissionAction.READ),
        collapse: 'general-setup',
        icontype: 'fa fa-user-plus',
        children: [
          { path: 'user-type', title: 'User Types', ab: 'UT' },
          { path: 'users', title: 'Users', ab: 'US' }
        ]
      },
      // icontype: 'fa fa-tachometer', icontype: 'fa fa-user-plus',
      // {
      //   path: '/help-faq',
      //   title: 'HELP & FAQs',
      //   type: 'link',
      //   icontype: 'nc-icon nc-email-85'
      // },
      //
      // {
      //   path: '/support',
      //   title: 'SUPPORT',
      //   type: 'link',
      //   icontype: 'nc-icon nc-bank'
      // }
    ]);
  }
}
